import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

export const BORROW_POSITIONS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: [
    {
      id: 'borrow',
      desc: true
    }
  ],
  columnFilters: [],
  columnOrder: [],
  version: 2
}
export const BORROW_POSITIONS_STORAGE_KEY = 'borrowPositionsTable'
